import { ITable } from 'utility-ts-database';
import { ILocalDatabase } from 'utility-ts-database';
import { IIndexable, key } from 'core-ts-types';

class LocalDatabaseDisconnected<T extends IIndexable> implements ITable<T> {
  constructor() {}
  isOpen() {
    return true;
  }
  isClosed() {
    return false;
  }
  ready(): Promise<this> {
    return new Promise((resolve) => resolve(this));
  }
  fail(): Promise<this> {
    return new Promise((resolve) => resolve(this));
  }
  open(): Promise<this> {
    return new Promise((resolve) => resolve(this));
  }
  close(): Promise<this> {
    return new Promise((resolve) => resolve(this));
  }
  putAll(values: T[] | Record<string, T>): Promise<this> {
    return new Promise((resolve) => resolve(this));
  }
  delAll(values: T[] | Record<string, T>): Promise<this> {
    return new Promise((resolve) => resolve(this));
  }
  get(k: string): Promise<T> {
    const db = sessionStorage.getItem(k);
    return new Promise((resolve) => resolve(JSON.parse(db!)));
  }
  read(): Promise<Record<string, T>> {
    return new Promise((resolve) => resolve({}));
  }
  write(values: T[] | Record<string, T>): Promise<Record<string, T>> {
    return new Promise((resolve) => resolve({}));
  }
  del(kOrV: T | key): Promise<string> {
    return new Promise((resolve) => resolve(''));
  }
  clear(): Promise<this> {
    sessionStorage.clear();
    return new Promise((resolve) => resolve(this));
  }
  put(v: T): Promise<T> {
    sessionStorage.setItem(v.id as string, JSON.stringify(v));
    return new Promise((resolve) => resolve(v));
  }
  cursor(set: Record<string, T> | T[]): T[] {
    return [];
  }
  exists(k: key): boolean {
    return false;
  }
  refresh(fn: (source: Record<string, T>) => Record<string, T>): Promise<Record<string, T>> {
    return new Promise((resolve) => resolve({}));
  }
  report(fn: (source: Record<string, T>) => any): Promise<any> {
    return new Promise((resolve) => resolve({}));
  }
}

angular.module('capability-ng-global').config(function($provide: any) {
  $provide.decorator('localDatabase', function($delegate: ILocalDatabase): ILocalDatabase {
    return new LocalDatabaseDisconnected<any>();
  });
});



// WEBPACK FOOTER //
// ./app/lib/global/configuration/hijack_local_database.ts